import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FacilityEdit } from 'src/app/facility/model/facility-edit';

@Injectable({
  providedIn: 'root'
})
export class FacilityService
{

  constructor(private http: HttpClient)
  {

  }

  /**
   * Check if Facility is in use
   *
   * @param id Facility id
   */
  public existsFacility(id: number): Observable<any>
  {
    return this.http.get(`/facility/inuse/${id}`);
  }

  /**
   * Get a Facility by id.
   *
   * @param id Facility id
   */
  public getFacilityById(id: number): Observable<FacilityEdit>
  {
    return this.http.get<FacilityEdit>(`/facility/${id}`);
  }

  /**
   * Get all facilities
   *
   */
  public getAllFacilities(): Observable<FacilityEdit[]>
  {
    return this.http.get<FacilityEdit[]>('/facilities/all');
  }

  /**
   * Delete a Facility.
   *
   * @param id Facility id
   */
  public deleteFacility(id: number): Observable<FacilityEdit>
  {
    return this.http.delete<FacilityEdit>(`/facility/${id}`);
  }

  /**
   * Check if Facility name exists to avoid duplicates
   *
   * @param name Facility name
   */
  public existsFacilityName(name: string): Observable<any>
  {
    return this.http.get(`/facility/exists?name=${name}`);
  }

  /**
   * Save a Facility.
   *
   * @param data Facility to persit
   * @param isNew Indicate if this is a new or update
   */
  public saveFacility(data: any, isNew: boolean, id?: number): Observable<any>
  {
    if (isNew)
    {
      return this.http.post('/facility', data);
    }
    else
    {
      return this.http.put(`/facility/${id}`, data);
    }
  }

}
